import React from "react";
import { Navigate, useParams } from "react-router-dom";

const RoleProtectedRoute = ({ children, allowedRoles }) => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user") || "null");
    const { coeName } = useParams();

    if (!token || !user) return <Navigate to="/" replace />;
    if (!allowedRoles.includes(user.role)) return <Navigate to="/admin" replace />;

    if (user.role === 'coe_report_viewer' && coeName && !['admin', 'mentor', 'college-viewer'].includes(coeName)) {
        const normalize = (val) => (val ? val.trim().toLowerCase().replace(/[\s-_]+/g, '') : '');
        const userCoe = user.coeName || user.coe_name || '';
        if (normalize(userCoe) !== normalize(coeName)) {
            const formattedUserCoe = userCoe ? userCoe.trim().replace(/\s+/g, '-') : 'coe';
            return <Navigate to={`/${formattedUserCoe}/learner-reviews`} replace />;
        }
    }

    return children;
};

export default RoleProtectedRoute;
